import { render, staticRenderFns } from "./SaveButtonComponent.vue?vue&type=template&id=5f0c30ec&"
import script from "./SaveButtonComponent.vue?vue&type=script&lang=js&"
export * from "./SaveButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports